import { BASE_URL } from '../constants/url'
import {
  AccessPointRankingResponse,
  ActivityResponse,
  AverageReconnectionsResponse,
  DashboardData,
  GroupsRankingResponse,
  NewUsersResponse,
  ReturningUsersResponse,
  TotalConnectionsResponse,
} from '../models/dashboardData'
import { client, downloadFile } from './baseService'

export const getCompany = async () => {
  try {
    const res = await client().get(`${BASE_URL}/company`)
    return res.data
  } catch (error) { }
}

export const getInfoDiario = async (
  id: string
): Promise<DashboardData | undefined> => {
  try {
    const res = await client().get(`${BASE_URL}/Dashboard/diario/${id}`)
    return res.data
  } catch (error) { }
}

export const getDataAp = async (id: string) => {
  try {
    downloadFile(`${BASE_URL}/Data/getApList/${id}`, 'ApList.csv')
  } catch (error) { }
}

export const getDataUseBand = async (id: string, idAp: number) => {
  try {
    downloadFile(
      `${BASE_URL}/Data/getPerformanceByAp/${id}/${idAp}`,
      'PerformanceByAp.csv'
    )
  } catch (error) {
    //alert(error.message);
  }
}

export const getDashboardData = async (options?: any) => {
  try {
    const res = await client().post(`${BASE_URL}/dashboard`, {}, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const getDashboardReport = async (options?: any) => {
  try {
    const res = await client().post(
      `${BASE_URL}/reports/dashboard`,
      {},
      options
    )
    return res.data
  } catch (error) {
    return false
  }
}

export const getVisitorsReport = async (options?: any) => {
  try {
    const res = await client().post(
      `${BASE_URL}/reports/visitors`,
      {},
      options
    )
    return res.data
  } catch (error) {
    return false
  }
}

export const getTotalAccessPerMonthReport = async (options?: any) => {
  try {
    const res = await client().get(`${BASE_URL}/reports/total-access-per-month`, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const getDailyAverageUsersReport = async (options?: any) => {
  try {
    const res = await client().get(`${BASE_URL}/reports/daily-average-users`, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const getMonthlyAverageUsersReport = async (options?: any) => {
  try {
    const res = await client().get(`${BASE_URL}/reports/monthly-average-users`, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const getPeakHoursReport = async (options?: any) => {
  try {
    const res = await client().get(`${BASE_URL}/reports/peak-hours`, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const getHeatmapDayHourReport = async (options?: any) => {
  try {
    const res = await client().get(`${BASE_URL}/reports/heatmap-day-hour`, options)
    return res.data
  } catch (error) {
    return false
  }
}

/**
 * Rotas granulares do Dashboard (documento NOVO_DASHBOARD.md).
 * Cada métrica do dashboard tem uma rota GET independente, autenticada
 * com `dashboard:view`. As funções abaixo recebem o mesmo `options`
 * (axios config) usado pelas demais chamadas, contendo `params`
 * com `time`, `dateStart`, `dateEnd` e opcionalmente `companyId`.
 */

export const getDashboardTotalConnections = async (
  options?: any
): Promise<TotalConnectionsResponse | false> => {
  try {
    const res = await client().get(
      `${BASE_URL}/dashboard/total-connections`,
      options
    )
    return res.data
  } catch (error) {
    return false
  }
}

export const getDashboardAverageReconnections = async (
  options?: any
): Promise<AverageReconnectionsResponse | false> => {
  try {
    const res = await client().get(
      `${BASE_URL}/dashboard/average-reconnections`,
      options
    )
    return res.data
  } catch (error) {
    return false
  }
}

export const getDashboardActivity = async (
  options?: any
): Promise<ActivityResponse | false> => {
  try {
    const res = await client().get(`${BASE_URL}/dashboard/activity`, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const getDashboardNewUsers = async (
  options?: any
): Promise<NewUsersResponse | false> => {
  try {
    const res = await client().get(`${BASE_URL}/dashboard/new-users`, options)
    return res.data
  } catch (error) {
    return false
  }
}

export const getDashboardReturningUsers = async (
  options?: any
): Promise<ReturningUsersResponse | false> => {
  try {
    const res = await client().get(
      `${BASE_URL}/dashboard/returning-users`,
      options
    )
    return res.data
  } catch (error) {
    return false
  }
}

export const getDashboardAccessPointRanking = async (
  options?: any
): Promise<AccessPointRankingResponse | false> => {
  try {
    const res = await client().get(
      `${BASE_URL}/dashboard/access-point-ranking`,
      options
    )
    return res.data
  } catch (error) {
    return false
  }
}

export const getDashboardGroupsRanking = async (
  options?: any
): Promise<GroupsRankingResponse | false> => {
  try {
    const res = await client().get(
      `${BASE_URL}/dashboard/groups-ranking`,
      options
    )
    return res.data
  } catch (error) {
    return false
  }
}
